import {
  CreateSliceOptions,
  PayloadAction,
  createSlice
} from '@reduxjs/toolkit'
import { SLICE_NAME } from './Selectors'
import { INITIAL_STATE, T_JSON_EVENT_DATA } from './Types'

const sliceOptions: CreateSliceOptions = {
  name: SLICE_NAME,
  initialState: INITIAL_STATE,
  reducers: {
    resetNriLoginAction: state => {
      state.nriLogin = false
    },
    nriLoginAction: state => {
      state.nriLogin = true
    },
    addNativeDisplayEvents: (
      state,
      action: PayloadAction<T_JSON_EVENT_DATA>
    ) => {
      const payload = action.payload

      if (!payload?.kv || typeof payload.kv !== 'object') return

      if (!state.nativeDisplayEvents) {
        state.nativeDisplayEvents = {}
      }

      if (
        'campaign_identifier' in payload.kv &&
        typeof payload.kv.campaign_identifier === 'string'
      ) {
        const key = payload.kv.campaign_identifier
        state.nativeDisplayEvents[key] = payload
      } else {
        state.nativeDisplayEvents = {
          ...state.nativeDisplayEvents,
          ...payload
        }
      }
    }
  }
}

const slice = createSlice(sliceOptions)

export const { resetNriLoginAction, nriLoginAction, addNativeDisplayEvents } =
  slice.actions

export default slice.reducer
